import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {OrganisationStore, OrganisationState} from './organisation.store';

@Injectable({providedIn: 'root'})
export class OrganisationQuery extends QueryEntity<OrganisationState> {

  constructor(protected store: OrganisationStore) {
    super(store);
  }

}
